import React, { Component } from 'react'
import { connect } from 'react-redux';
import AsSwitch from './airship-wrappers/AsSwitch'
import { withCarto } from '../carto/withCarto';

export class DpsQueryModifier extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedValues: [...props.values]
    }
  }

  onChanged = (event) => {
    this.props.layerNames.forEach(layer => {
      this.props.CartoContext.updateLayerFilter(layer, this.props.field, event.detail ? this.props.values : [], this.props.label)
    })
    if (event.detail) this.setState(state => ({
      ...state,
      selectedValues: [...this.props.values]
    }))
  }

  onValueChanged = (checked, value) => {
    this.setState(state => ({
      ...state,
      selectedValues: !checked ? state.selectedValues.filter(val => val !== value) : [ value, ...state.selectedValues ]
    }), () => {
      this.props.layerNames.forEach(layer => {
        this.props.CartoContext.updateLayerFilter(layer, this.props.field, this.state.selectedValues.length ? this.state.selectedValues : [], this.props.label)
      })
    })
    
  }

  isChecked = () => {
    const layer = this.props.layers[this.props.layerNames[0]] 
    return layer.filters[this.props.field] && layer.filters[this.props.field].length
  }

  render() {
    return (
      <div className="dps-query-modifier">
        <AsSwitch label={this.props.label} onChanged={this.onChanged} checked={this.isChecked()}></AsSwitch>
        {this.props.values.length === 1 && <span role="tooltip" className="as-tooltip as-tooltip--top">{this.props.values[0]}</span>}
        {this.isChecked() && this.props.values.length > 1 && <form>
          {this.props.values.map(val => (<div key={val} className="as-checkbox">
            <input className="as-checkbox-input" type="checkbox" name={val} checked={this.state.selectedValues.includes(val)} onChange={({target}) => this.onValueChanged(target.checked, val)} disabled={this.state.selectedValues.includes(val) && this.state.selectedValues.length <= 1} />
            <span className="as-checkbox-decoration">
              <svg className="as-checkbox-media">
                <polyline className="as-checkbox-check" points="1.65093994 3.80255127 4.48919678 6.97192383 10.3794556 0.717346191"></polyline>
              </svg>
            </span>
            <label className="as-caption" htmlFor={val}> {val}</label>
          </div>))}
        </form>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(DpsQueryModifier));
